import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IClient } from '@pec/aion-ui-core/interfaces/client';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';

const name = 'ngqeClients';

type ClientParams = {
  organizationId: string;
  organizationFeatures: OrganizationFeature[];
};

export const fetchNgqeClients = createAsyncThunk(
  `${name}/fetch`,
  async ({ organizationId, organizationFeatures }: ClientParams, { dispatch }) => {
    try {
      const responses = await axios.all(
        organizationFeatures.map(featureFilter =>
          axios.get<IClient[]>(`/api/v2/organizations/${organizationId}/clients`, {
            params: {
              featureFilter
            }
          })
        )
      );

      const clients = responses.map(response => response.data);

      const commonClients: IClient[] = clients.reduce((common, clientList) => {
        return common.filter(client => clientList.some(c => c.id === client.id));
      });

      return commonClients;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  ngqeClients: IClient[] | null;
};

const initialState: State = {
  ngqeClients: null,
  isFetching: false,
  error: null
};

const ngqeClients = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchNgqeClients.pending, isFetching)
      .addCase(fetchNgqeClients.fulfilled, (state, action) => {
        state.ngqeClients = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchNgqeClients.rejected, error);
  }
});

export const { reducer: ngqeClientsReducer } = ngqeClients;
